module.exports = __webpack_public_path__ + "static/media/Hero_canada_temp_1200_q40.c9a35afe.webp";